import { useHasMultipleReferralInvites } from '@/components/layouts/ReferralInviteLayout/hooks/useHasMultipleReferralInvites'

export function useReferralsTerm() {
  const hasMultipleInvites = useHasMultipleReferralInvites()

  return hasMultipleInvites ? 'the referrals' : 'the referral'
}
